import script from "./TableTravel.vue?vue&type=script&setup=true&lang=js"
export * from "./TableTravel.vue?vue&type=script&setup=true&lang=js"

import "../styles/table.css?vue&type=style&index=0&id=2e57d820&scoped=true&lang=css&external"
import "./TableTravel.vue?vue&type=style&index=1&id=2e57d820&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e57d820"]])

export default __exports__